import {view, Icon} from '@sail/ui';
import {IconAsset} from '@sail/icons/types';

type NetworkIconsStackProps = {
  icons: Array<{icon: IconAsset; name: string}>;
};

export const NetworkIconsStack = ({icons}: NetworkIconsStackProps) => {
  return (
    <view.div
      css={{
        stack: 'z',
        width: 'fit',
        height: 'fit',
      }}
    >
      {icons
        .slice()
        .reverse()
        .map((iconData, index) => (
          <Icon
            key={iconData.name}
            icon={iconData.icon}
            size="medium"
            css={{
              borderRadius: '5px',
              border: '1px solid white',
              alignSelfX: 'end',
              marginRight: `${(icons.length - 1 - index) * 12}px`,
            }}
          />
        ))}
    </view.div>
  );
};
